import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetFixFlipField } from '../../../../../queries/useBudgetFixFlipField';

interface Item2Props {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Item2: React.FC<Item2Props> = ({ required = false, propertyGuid, isReview = false }) => {
    const [item2, set_item2] = useBudgetFixFlipField<number>(
        propertyGuid,
        (b) => (b.values?.['Expand Primary Structure']?.['Item #2']?.[1] as number) ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Expand Primary Structure': { ...b.values?.['Expand Primary Structure'], 'Item #2': [b.values?.['Expand Primary Structure']?.['Item #2']?.[0] ?? '', v] as [string, number] } } })
    );
    const label = 'Item #2';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(item2)}
                />
            ) : (
                <MoneyBox
                    id={'item2'}
                    allowNegative={false}
                    value={item2}
                    onChange={(value) => set_item2(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
